import * as React from "react";

function IcSystemInvite(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 24,
    height = 24,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemInvite"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M19.5 21H4.5C4.5 21 5 14 12 14M12 2.5V2.5C14.2091 2.5 16 4.29086 16 6.5V7.5C16 9.70914 14.2091 11.5 12 11.5V11.5C9.79086 11.5 8 9.70914 8 7.5V6.5C8 4.29086 9.79086 2.5 12 2.5Z"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 10C18.4477 10 18 10.4477 18 11V13H16C15.4477 13 15 13.4477 15 14C15 14.5523 15.4477 15 16 15H18V17C18 17.5523 18.4477 18 19 18C19.5523 18 20 17.5523 20 17V15H22C22.5523 15 23 14.5523 23 14C23 13.4477 22.5523 13 22 13H20V11C20 10.4477 19.5523 10 19 10Z"
        fill={color}
      />
    </svg>
  );
}

export default IcSystemInvite;
